import memoize from 'lodash/memoize';
import moment from 'moment-timezone';

export interface DayAppointmentMap<T extends Date | string = Date> {
  [date: string]: T[];
}

export const createDayMap = memoize(
  <T extends Date | string>(
    allDates: T[],
    filter: (a: T) => boolean = () => true,
    extra?: T,
    timezone?: string,
  ): DayAppointmentMap<T> => {
    let dayHoursMap: DayAppointmentMap<T> = {};

    const filteredDates = allDates.filter(filter);

    const dates: T[] = extra ? [...filteredDates, extra] : filteredDates;

    dates
      .sort((a: T, b: T) => moment(a).diff(moment(b)))
      .forEach((date: T) => {
        const mDate = timezone ? moment.tz(date, timezone) : moment(date);
        const day = mDate.startOf('day').format('YYYY-MM-DD');
        if (!dayHoursMap[day]) {
          dayHoursMap[day] = [];
        }
        dayHoursMap[day].push(date);
      });
    return dayHoursMap;
  },
);

const futureFilter = () => (date: Date) => moment(date).isAfter(moment());

export const createFutureDayMap = memoize(
  (dates: Date[], extra?: Date, timezone?: string): DayAppointmentMap => {
    return createDayMap(dates, futureFilter(), extra, timezone);
  },
);
